export default __webpack_public_path__ + "static/media/promo-how-far-will-fudge-go_04.f28cef48.jpg";